import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { UserService } from 'src/app/shared/services/node-api/user.service';

@Component({
  selector: 'app-companies-following-component',
  templateUrl: './companies-following.component.html',
  styleUrls: ['./companies-following.component.scss'],
})
export class CompaniesFollowingComponent implements OnInit {
  userEmail: any;
  companiesList: any;

  constructor(
    private userService: UserService,
    private localStorageService: LocalStorageService
  ) {
    // console.log('hello');
  }

  ngOnInit(): void {
    this.userEmail = this.localStorageService.getItem('email');
    this.userService
      .userData({ email: this.userEmail })
      .then((data: any) => {
        this.companiesList = data.company_follow_list;
      })
      .catch((err) => {
        console.log(err);
      });
  }
}
